/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import './DeleteGVAUserModal.scss';

import React, {useEffect, useState} from 'react';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import { AAMBeaconButton, AAMBeaconModal } from 'components/shared/Beacon';
import { connect } from 'react-redux';
import {
  getGrantViewAccessDeleteUserSuccessStatus,
  getGrantViewAccessDeleteUserFailureStatus
} from 'state/grantViewAccess/GrantViewAccessSelectors';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

const DeleteGVAUserModal = ({
  onCancel,
  onSubmit,
  userToDelete,
  isDeleteGrantViewAccessUserReceived,
  isGrantViewDeleteStatusFailure,
  isCustomerWebView
}) => {
  const [showSpinner, setShowSpinner] = useState(false);

  const fullName =
  userToDelete && userToDelete.customer
    ? userToDelete.customer.fullName
    : '';

  useEffect(() => {
    setShowSpinner(false);
  }, [isDeleteGrantViewAccessUserReceived,  isGrantViewDeleteStatusFailure]);

  return (
    <div slot="action-zone">
      <AAMBeaconModal
        containerClassName="delete-user-modal"
        id="delete-user-modal"
        disableClickOff
        hideAnchor
        hideClose
        onBeaconEventClose={onCancel}
        open
        className
        title=" ">
        <div className="delete-user-modal-content">
          Are you sure you want to delete {fullName}?
        </div>
        <div className="delete-user-modal-buttons">
          <AAMBeaconButton
            className="cancel"
            id="cancel-delete-user"
            variant="tertiary"
            onBeaconEventClick={() => onCancel()}
          >
            Cancel
          </AAMBeaconButton>
          {showSpinner && (
            <div className="loading-spinner">
              <Spinner />
            </div>
          )}
          {!showSpinner && (
            <AAMBeaconButton
              id="delete-user-submit"
              variant="primary"
              scale="normal"
              onBeaconEventClick={() => {
                onSubmit();
                setShowSpinner(true);
              }}
              disabled={isCustomerWebView}
            >
                Delete
            </AAMBeaconButton>
          )}
        </div>
      </AAMBeaconModal>
    </div>
  );
};
const mapStateToProps = (state) => ({
  isDeleteGrantViewAccessUserReceived: getGrantViewAccessDeleteUserSuccessStatus(state),
  isgrantviewDeleteStatusfailure:getGrantViewAccessDeleteUserFailureStatus(state),
  isCustomerWebView: getCustomerWebView(state),
});
export default connect(mapStateToProps)(DeleteGVAUserModal);
